import { TextInput } from '@mantine/core'
import { AxiosResponse } from 'axios'

interface Props {
  inputProps: any
  callback?: (data: AxiosResponse | undefined, status: number | undefined) => void
}

export const FirstName = ({ inputProps }: Props) => (
  <TextInput {...inputProps} placeholder="Primeiro nome" type="text" />
)

export const LastName = ({ inputProps }: Props) => (
  <TextInput {...inputProps} placeholder="Sobrenome" type="text" />
)

export const Email = ({ inputProps }: Props) => (
  <TextInput {...inputProps} placeholder="E-mail" type="email" />
)

export const PhoneNumber = ({ inputProps }: Props) => (
  <TextInput {...inputProps} placeholder="Telefone" type="text" />
)

export const TaxDocument = ({ inputProps }: Props) => (
  <TextInput {...inputProps} placeholder="CPF" type="text" />
)

export const Birthdate = ({ inputProps }: Props) => (
  <TextInput {...inputProps} placeholder="Nascimento (dd/mm/aaaa)" type="text" />
)

export const Postcode = ({ inputProps }: Props) => (
  <TextInput {...inputProps} placeholder="CEP" type="text" />
)

export const AddressLine1 = ({ inputProps }: Props) => (
  <TextInput {...inputProps} placeholder="Endereço" type="text" />
)

export const AddressNumber = ({ inputProps }: Props) => (
  <TextInput {...inputProps} placeholder="Número" type="text" />
)

export const AddressComplement = ({ inputProps }: Props) => (
  <TextInput {...inputProps} placeholder="Complemento" type="text" />
)

export const City = ({ inputProps }: Props) => (
  <TextInput {...inputProps} placeholder="Cidade" type="text" />
)

export const StateCode = ({ inputProps }: Props) => (
  <TextInput {...inputProps} placeholder="Estado (UF)" type="text" />
)

export const Password = ({ inputProps }: Props) => (
  <TextInput {...inputProps} placeholder="Senha" type="password" />
)

export const ConfirmPassword = ({ inputProps }: Props) => (
  <TextInput {...inputProps} placeholder="Confirmar Senha" type="password" />
)
